<template>
  <a-card :bordered="false" class="m-t-10" :hidden='historyLength == 1'>
    <a-button size='small' @click="()=>{$router.go(-1)}">
      <LeftOutlined />返回
    </a-button>
    <span class="ml15 card_title">调仓单详情</span>
  </a-card>
  <a-card :bordered="false">
    <div class="s_flex_bian">
      <a-descriptions title="调仓单操作" class="width80" :column='5'>
        <a-descriptions-item label="订单状态">{{orderData.transfer_status_text}}</a-descriptions-item>
        <a-descriptions-item label="调仓单号" :span='4'>{{orderData.transfer_warehousing_sn}}</a-descriptions-item>
        <a-descriptions-item label="备注" :span='5'>{{orderData.remark}}</a-descriptions-item>
      </a-descriptions>
      <img class="width-150 height-150" src="@/assets/images/user.png" alt="">
    </div>
    <div class="m-t-10 p-b-10">
      <a-button class="width-100 m-r-20" block @click='closeOrder' v-if='orderData.transfer_status == 1'>关闭订单</a-button>
      <a-button class="width-100" block type="primary" v-if='orderData.transfer_status == 1'>打印</a-button>
    </div>
    <a-descriptions title="创建人详情" :column='1' class="m-t-20">
      <a-descriptions-item label="创建人">{{orderData.create_role_name}}</a-descriptions-item>
      <a-descriptions-item label="联系电话">{{orderData.create_role_phone}}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions title="出库单详情" :column='1' class="m-t-20">
      <a-descriptions-item label="调出仓库">{{orderData.transfer_warehouse_name}}</a-descriptions-item>
      <a-descriptions-item label="调入仓库">{{orderData.transfer_to_warehouse_name}}</a-descriptions-item>
      <a-descriptions-item label="创建时间">{{orderData.created_at}}</a-descriptions-item>
      <a-descriptions-item label="出库时间" v-if='orderData.transfer_status == 2'>{{orderData.transfer_warehousing_time}}</a-descriptions-item>
      <a-descriptions-item label="关闭时间" v-if='orderData.transfer_status == 3'>{{orderData.close_time}}</a-descriptions-item>
    </a-descriptions>
    <div class="fz-16 s_font_b m-t-20">商品详情</div>
    <a-table class='m-t-25' :pagination='false' bordered rowKey='id' :columns='columns'
      :data-source='orderData.product'>
      <template v-slot:gift_name="{ record }">
        <a-card-meta>
          <template #avatar>
            <img :src="info.picdomain+'/'+(record.product_image)" alt="" style="width:50px;height:50px">
          </template>
          <template #description>
            <p class="s_omit2" style="width: 320px;">{{record.product_name}}</p>
          </template>
        </a-card-meta>
      </template>
      <template v-slot:action="{ record }">
        <a-button type="link" @click='showCode = true;itemId = record.product_id'>查看出货二维码</a-button>
      </template>
    </a-table>
  </a-card>
  <a-modal :keyboard="false" title="出货二维码" :width='1300' centered v-model:visible="showCode" destroyOnClose :footer='null'>
    <shippingCode :id='itemId' :showLast='true' :sn='$route.query.id' type='transfer'></shippingCode>
  </a-modal>
</template>

<script>
  import { LeftOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs, h } from "vue";
  import { message } from "ant-design-vue";
  import store from "@/store";
  import { getTransferWarehousingMore, closeTransferWarehousing } from "@/api/antiFleeing";
  import { iscode } from "@/utils/app";
  import shippingCode from '../../components/shippingCode.vue' 
  export default {
    components: { LeftOutlined,shippingCode },
    setup() {
      const state = reactive({
        info: store.state.user.info,
        orderData: {},
        goodList: [],
        showCode:false,
        itemId:'',
        historyLength:0,
        columns: [
          {
            title: "商品编码",
            dataIndex: "product_sn",
            key: "product_sn"
          },
          {
            title: "商品信息",
            dataIndex: "gift_name",
            key: "gift_name",
            slots: { customRender: "gift_name" },
          },
          {
            title: "规格",
            dataIndex: "product_sku_name",
            key: "product_sku_name",
            customRender:({record})=>{
              return record.product_sku_name ? record.product_sku_name:'单规格'
            } 
          },
          {
            title: "数量",
            dataIndex: "transfer_warehousing_num",
            key: "transfer_warehousing_num",
          },
        ]
      });
      const $route = inject("$route");
      const $Modal = inject("$Modal");
      const $router = inject("$router");
      //获取详情
      const initData = async () => {
        const hide = message.loading("正在加载中...", 0);
        let res = await getTransferWarehousingMore($route.query.id ).then((res) => res.data).catch(error => error);
        if (iscode(res)) {
          if(res.data.transfer_status == 2){
            state.columns.push({
              title: "操作",
              key: "action",
              slots: { customRender: "action" }
            })
          }
          state.orderData = res.data;
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);
      };
      //关闭订单
      const closeOrder = () => {
        $Modal.confirm({
          title: '确定关闭订单？',
          centered: true,
          content: h('div', {}, [
            h('p', '1、订单关闭后将无法开启'),
            h('p', '2、关闭订单后，商品移回原仓库，进行拆箱发货的中标和大标依然无效'),
          ]),
          async onOk() {
            let res = await closeTransferWarehousing( $route.query.id).then((res) => res.data);
            if (iscode(res, true)) {
              initData();
            }
          },
        });
      }
      onMounted(() => {
        initData();
        state.historyLength = window.history.length
      });
      return {
        ...toRefs(state),
        closeOrder
      };
    },
  };
</script>